$(document).on('mouseenter', '.card', (e) => {
  const card = e.target.closest('.card');
  const bkgHover = card.getAttribute('data-bkg-hover');
  card.style.backgroundColor=`${bkgHover}`;
});

$(document).on('mouseleave', '.card', (e) => {
  const card = e.target.closest('.card');
  const bkg = card.getAttribute('data-bkg');
  card.style.backgroundColor=`${bkg}`;
});